class PostListFilters {
  constructor({ breakpoint = 480 } = {}) {
    this.toggleEl = document.querySelector('.b-post-list-filters__toggle');
    this.targetEl = document.querySelector('.b-post-list-filters__wrap');
    this.breakpointQuery = `(min-width: ${breakpoint}px)`;

    this.mql = window.matchMedia(this.breakpointQuery);
  }

  show() {
    this.targetEl.setAttribute('aria-hidden', false);
    this.toggleEl.setAttribute('aria-expanded', true);
  }

  close() {
    this.targetEl.setAttribute('aria-hidden', true);
    this.toggleEl.setAttribute('aria-expanded', false);
  }

  toggle() {
    if (this.targetEl.getAttribute('aria-hidden') === 'true') {
      this.show();
    } else {
      this.close();
    }
  }

  handleBreakpoint() {
    if (this.mql.matches) {
      this.show();
    }
  }

  registerEvents() {
    if (this.toggleEl) this.toggleEl.addEventListener('click', () => { this.toggle(); });

    this.mql.addListener(() => { this.handleBreakpoint(); });
  }

  mount() {
    if (this.targetEl) {
      this.registerEvents();
      this.handleBreakpoint();
    }
  }
}

function init() {
  new PostListFilters().mount();
}

export default {
  init,
};
